package dk.smark.demo.map

import kotlin.math.*

object TileMath {
    fun latLonToTile(lat: Double, lon: Double, zoom: Int): Pair<Int, Int> {
        val n = 2.0.pow(zoom)
        val x = ((lon + 180.0) / 360.0 * n).toInt()
        val latRad = lat * PI / 180.0
        val y = ((1.0 - ln(tan(latRad) + 1.0 / cos(latRad)) / PI) / 2.0 * n).toInt()
        return x to y
    }

    fun latLonToPixel(lat: Double, lon: Double, zoom: Int): Pair<Double, Double> {
        val n = 2.0.pow(zoom)
        val px = (lon + 180.0) / 360.0 * n * 256.0
        val latRad = lat * PI / 180.0
        val py = (1.0 - ln(tan(latRad) + 1.0 / cos(latRad)) / PI) / 2.0 * n * 256.0
        return px to py
    }

    fun tileUrl(x: Int, y: Int, zoom: Int): String =
        "https://tile.openstreetmap.org/$zoom/$x/$y.png"
}